import {LayoutDashboard, Search, User} from 'lucide-react'

/**
 * The primary destinations, in the order they appear in both the bottom tab
 * bar and the desktop side nav (T-WEB-08). One list so the two can never
 * disagree about what "primary" means.
 */
export const PRIMARY_NAV = [
  {href: '/dashboard', key: 'dashboard', Icon: LayoutDashboard},
  {href: '/search', key: 'search', Icon: Search},
  {href: '/profile', key: 'profile', Icon: User}
] as const

export type NavItem = (typeof PRIMARY_NAV)[number]
